/**
 * Dashboard > Dashboard - 실시간 이상 검출 건수 component
 */
import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'LiveFaultDetectionStatus',
  mounted () {
    this.search()
  },
  methods: {
    /**
     * Chart Data 조회 (실시간 이상 검출 건수)
     */
    async search () {
      const payload = {
        // fab: 'BRIQUE'
      }

      await API.Monitor.getFaultDetectionStatus(payload, this.callbackFaultDetectionStatus, [this.$refs.liveFaultDetectionStatusChart])
    },
    /**
     * Chart Data 조회 callback
     * @param {*} response Chart Data 조회 결과
     */
    callbackFaultDetectionStatus (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      traces.forEach(trace => {
        trace.hovertemplate = '%{y:,}'
      })
      const layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        xaxis: {
          type: 'category',
          tickangle: -45
        },
        hovermode: 'x unified'
      }
      const config = {
        responsive: true,
        displayModeBar: false
      }
      BriqueChart.newPlot('liveFaultDetectionStatusChart', traces, layout, config)
    }
  },
  data () {
    return {
      rowData: [] // chart data
    }
  }
}
